import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { UNAUTHORIZED_EVENT } from '../lib/api';
import { useToast } from '../contexts/ToastContext';

/**
 * Listens for the global 401 event raised by the API layer and reacts once
 * per burst: shows a toast and redirects to /login. Auth state itself is
 * cleared by AuthProvider, which listens to the same event. Renders nothing.
 */
const ApiErrorBridge: React.FC = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const lastFired = useRef(0);

  useEffect(() => {
    const handler = () => {
      const now = Date.now();
      if (now - lastFired.current < 3000) return; // de-dupe bursts of 401s
      lastFired.current = now;
      toast.error('Your session has expired. Please sign in again.');
      navigate('/login', { replace: true });
    };
    window.addEventListener(UNAUTHORIZED_EVENT, handler);
    return () => window.removeEventListener(UNAUTHORIZED_EVENT, handler);
  }, [navigate, toast]);

  return null;
};

export default ApiErrorBridge;
